import React from "react"
import { useSearchBox } from "react-instantsearch"

const SearchBox = ({ className, onFocus, onChange }) => {
  const { query, refine } = useSearchBox()

  return (
    <form className={className}>
      <span className="SearchIcon">
        <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.43753 14.8438C9.08805 14.8441 10.6835 14.25 11.9319 13.1704L15.1725 16.411C15.2165 16.4729 15.2733 16.5247 15.3391 16.5628C15.4048 16.601 15.4779 16.6245 15.5536 16.632C15.6292 16.6394 15.7055 16.6305 15.7774 16.606C15.8493 16.5814 15.9151 16.5417 15.9703 16.4895C16.0256 16.4373 16.069 16.3739 16.0976 16.3035C16.1263 16.2332 16.1395 16.1574 16.1364 16.0815C16.1333 16.0056 16.1139 15.9312 16.0796 15.8634C16.0453 15.7956 15.9969 15.736 15.9375 15.6885L12.6969 12.4479C13.7253 11.2554 14.3153 9.74724 14.369 8.17347C14.4228 6.59971 13.9372 5.05482 12.9926 3.7949C12.048 2.53498 10.7012 1.63568 9.17549 1.24609C7.64977 0.856494 6.03671 0.999994 4.60372 1.6528C3.17073 2.30561 2.00385 3.42852 1.29652 4.8354C0.589181 6.24228 0.383868 7.84864 0.71461 9.38819C1.04535 10.9278 1.89228 12.3081 3.11502 13.3003C4.33775 14.2925 5.86286 14.8371 7.43753 14.8438ZM7.43753 2.09381C8.59331 2.09381 9.72314 2.43654 10.6841 3.07866C11.6451 3.72078 12.3942 4.63345 12.8365 5.70126C13.2788 6.76906 13.3945 7.94405 13.169 9.07763C12.9435 10.2112 12.3869 11.2525 11.5697 12.0697C10.7524 12.887 9.71117 13.4435 8.57759 13.669C7.44401 13.8945 6.26903 13.7788 5.20122 13.3365C4.13342 12.8942 3.22075 12.1452 2.57863 11.1842C1.93651 10.2232 1.59378 9.09335 1.59378 7.93757C1.59378 6.38771 2.20946 4.90133 3.30537 3.80541C4.40129 2.70949 5.88767 2.09381 7.43753 2.09381Z" fill="white"/>
        </svg>
      </span>
      <input
        className="SearchInput"
        type="text"
        placeholder="Search"
        aria-label="Search"
        onChange={e => {
          refine(e.target.value)
          onChange(e.target.value)
        }}
        value={query}
        onFocus={onFocus}
      />
    </form>
  )
}

export default SearchBox